import axios from "axios";


export interface Unit {
    id?: string;
    name: string;
    UnitType: string;
    Value: number;
}
export async function fetchUnits(): Promise<Unit[]> {
    const response = await axios.get("/Unit/get");
    return response.data;
}
